/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { CollectionView } from 'backbone.marionette';

import SelectFieldItemView from './SelectFieldItemView';

const SelectFieldCollectionView = CollectionView.extend({
  childView: SelectFieldItemView,

  options: {
    isDisabled: false,
    isRequired: false,
    emptyOption: '--',
    name: null,
    attributes: null,
    selectClass: null,
    multiple: false,
  },

  tagName: 'select',

  className() {
    const baseClass = 'select-field-collection-view form-control';
    if (this.options.selectClass) {
      return `${baseClass} ${this.options.selectClass}`;
    }
    return baseClass;
  },

  onBeforeRender() {
    const { isDisabled, emptyOption } = this.options;
    this.isDisabled = Boolean(isDisabled);

    if (emptyOption) {
      this.collection.unshift({
        value: '',
        text: emptyOption,
      });
    }
  },

  onRender() {
    const { isRequired, name, multiple } = this.options;
    const attributes = {};
    if (isRequired) {
      attributes['data-parsley-required'] = 'true';
    }
    if (name) {
      attributes.name = name;
    }
    if (multiple) {
      attributes.multiple = 'multiple';
      if (isRequired) {
        Object.assign(attributes, {
          'data-parsley-validate-if-empty': 'true',
          'data-parsley-trigger-after-failure': 'change.select2',
        });
      }
    }
    if (this.options.attributes) {
      Object.assign(attributes, this.options.attributes);
    }
    this.$el.attr(attributes);
    if (this.isDisabled) {
      this.$el.prop('disabled', true);
    }
  },

  setDisabled(isDisabled) {
    this.isDisabled = isDisabled;
    this.$el.prop('disabled', this.isDisabled);
    if (this.isDisabled) {
      this.$el.parsley().reset();
    }
    return this;
  },

  setValue(value) {
    this.$el.val(value).trigger('change');
    return this;
  },

  getValue() {
    return this.$el.val();
  },
});

export default SelectFieldCollectionView;
